
var xsubmit = false;
var x;

function render(frm){ 
	$('#turnstilemodal').appendTo('body') 
	$('#turnstilemodal').modal()
	
	x = turnstile.render('#example-container', {
		sitekey: tssk,
		callback: function(token) {
			xsubmit = true;
			frm.trigger('submit')
		},
		errorCallback: function(e) {
			xsubmit = false;
			$('#turnstilemodal').modal('hide')
			console.log('Es scheint als seien Sie kein Mensch')
			alert('Es scheint als seien Sie kein Mensch ;-) Versuche es nocheinmal.')
		},
		expiredCallback: function(e) {
			xsubmit = false;
			$('#turnstilemodal').modal('hide')
			console.log('Die Challenge ist abgelaufen')
			alert('Die Challenge ist abgelaufen. Versuche es nocheinmal.')
		},
		unsupportedCallback: function(e) {
			xsubmit = true;
			frm.trigger('submit')
		},
		timeoutCallback: function(e) {
			xsubmit = false;
			$('#turnstilemodal').modal('hide')
			console.log('Die Challenge hat zuviel Zeit in Anspruch genommen')
			alert('Die Challenge hat zuviel Zeit in Anspruch genommen. Versuche es nocheinmal.')
		}
	});
}

$('.formgen').validator().on('submit', function (e) {
	var _this = this;
	if (!e.isDefaultPrevented()) {
		e.preventDefault()
		if(!xsubmit){
			render($(_this))  
		}
		else{		
			$('#turnstilemodal').appendTo(_this)
			$('#turnstilemodal').modal('hide')
			var data = new FormData($(_this)[0]);
			showLoading(true)
			turnstile.remove()
			$.ajax({
				url: '/assets/inc/form-processor.cfm?lang='+lang,
				data: data,
				cache: false,
				contentType: false,
				processData: false,
				method: 'POST',
				type: 'POST',
				success: function(ret){	
					var retObj = ret;
					if(retObj['STATE']){
						// succeded
						$(_this).append('<div data-conversion="'+retObj['CONVERSIONTAG']+'"></div>')

						if(typeof gtag === 'function' && $(_this).find('[data-conversion]').attr('data-conversion').trim().length ){
							gtag('event','courseregistration', {
								'course_name' : $('[name="veranstaltung"]',_this).find('option').last().attr('data-course'), 
								'course_date' : $(_this).find('[name="veranstaltung"]').val(),
								'course_participants' : $(_this).find('[name="anzahl"]').val()
							}) 
						}
						else if(typeof gtag === 'function'){
							gtag('event','formgen_sent', {
								'action_url' : $(_this).attr('action'), 
							}) 	
						}

						$(_this).html(retObj['MSG'])
						
						window.location = '#' + $('form').first().closest('section').attr('id')
						
						/*if(retObj['conversiontag'].trim() != ''){
							$(_this).html(retObj['msg'] + '<div data-conversion="'+retObj['conversiontag']+'"></div>')
						}*/
					}
					else{
						// failed
						alert(retObj['MSG'])	
					}	
					showLoading(false)
					xsubmit = false;
					window.dispatchEvent(new Event("resize"))
				},
				error: function () {
					alert('Konnte nicht erfolgreich abgeschlossen werden')	
					showLoading(false)
					xsubmit = false;
					window.dispatchEvent(new Event("resize"))
				}
			});
		}
	}
	return false
})



$('.formgensidecontact').validator().on('submit', function (e) {
	var _this = this;
	if (!e.isDefaultPrevented()) {
		e.preventDefault()
		if(!xsubmit){
			render($(_this))  
		}
		else{		
			$('#turnstilemodal').appendTo(_this)
			$('#turnstilemodal').modal('hide')
			var data = new FormData($(_this)[0]);
			showLoading(true)
			turnstile.remove()
			$.ajax({
				url: '/assets/inc/form-processor-sidecontact.cfm?lang='+lang,
				data: data,
				cache: false,
				contentType: false,
				processData: false,
				method: 'POST',
				type: 'POST',
				success: function(ret){	
					var retObj = ret;
					if(retObj['STATE']){
						// succeded
						
						$(_this).html(retObj['MSG'] + '<div data-conversion="'+retObj['conversiontag']+'"></div>')
						/*gtag('event', 'conversion', {
							 'send_to': retObj['conversiontag'],
							 'value': 0.5,
							 'currency': 'CHF'
						});*/
						
						if(typeof gtag === 'function' ){
							gtag('event','sentQuickContact', {
								'sent_country' : langdouble + '-' + ctry
							}) 
						}
					}
					else{
						// failed
						alert(retObj['MSG'])	
					}	
					showLoading(false)
					xsubmit = false;
					window.dispatchEvent(new Event("resize"))
					
				},
				error: function () {
					alert('Konnte nicht erfolgreich abgeschlossen werden')	
					showLoading(false)
					xsubmit = false;
					window.dispatchEvent(new Event("resize"))
				}
			});
		}
	}
	return false
})


//$('button.dismiss').on('click',function(e){
//	e.preventDefault()
//	$('#install,#update').hide()
//});
//
//
//  const INSTALL_BOX_ID = '#install';
//  const DISMISS_KEY = 'pwa_install_dismissed_until'; // ISO date string
//  const DISMISS_COOLDOWN_DAYS = 7;
//
//  let deferredPrompt = null;
//
//  function daysFromNow(n) {
//    const d = new Date();
//    d.setDate(d.getDate() + n);
//    return d.toISOString();
//  }
//
//  function isStandalone() {
//    return window.matchMedia('(display-mode: standalone)').matches
//      || window.navigator.standalone === true; // iOS Safari
//  }
//
//  function installBox(show) {
//    const $box = $(INSTALL_BOX_ID);
//    if (!$box.length) return $(); // noop
//    if (show) $box.show(); else $box.hide();
//    return $box;
//  }
//
//  function bindInstallBoxHandlers() {
//    const $box = $(INSTALL_BOX_ID);
//    if (!$box.length) return;
//
//    // Install
//    $box.find('button.install').off('click').on('click', async (ev) => {
//      ev.preventDefault();
//      if (!deferredPrompt) return;
//      deferredPrompt.prompt();
//      const { outcome } = await deferredPrompt.userChoice;
//      if (outcome === 'accepted') {
//        deferredPrompt = null;
//        installBox(false);
//        localStorage.removeItem(DISMISS_KEY);
//      }
//    });
//
//    // Dismiss
//    $box.find('button.dismiss').off('click').on('click', (ev) => {
//      ev.preventDefault();
//      installBox(false);
//      localStorage.setItem(DISMISS_KEY, daysFromNow(DISMISS_COOLDOWN_DAYS));
//    });
//  }
//
//  function maybeShowInstallBox() {
//    // Nur zeigen, wenn nicht bereits installiert
//    if (isStandalone()) { installBox(false); return; }
//
//    // Cooldown prüfen
//    const until = localStorage.getItem(DISMISS_KEY);
//    if (until && new Date(until) > new Date()) {
//      installBox(false);
//      return;
//    }
//
//    // Nur anzeigen, wenn ein Prompt möglich ist
//    if (deferredPrompt) {
//      installBox(true);
//      bindInstallBoxHandlers();
//    }
//  }
//
//  function invokeServiceWorkerUpdateFlow(reg) {
//    const $ui = $('#update');
//    if (!$ui.length) return;
//    //$ui.show();
//    /*$ui.find('button').off('click').on('click', () => {
//      reg?.waiting?.postMessage('SKIP_WAITING');
//    });*/
//  }
//
//  // ---- Service Worker Registration + Update Flow
//  if ('serviceWorker' in navigator) {
//    window.addEventListener('load', async () => {
//      try {
//        const reg = await navigator.serviceWorker.register('/serviceworker.js', { scope: '/' });
//
//        // verpasste updatefound-Events sicher abdecken
//        if (reg.waiting) invokeServiceWorkerUpdateFlow(reg);
//
//        reg.addEventListener('updatefound', () => {
//          const sw = reg.installing;
//          if (!sw) return;
//          sw.addEventListener('statechange', () => {
//            if (reg.waiting) {
//              if (navigator.serviceWorker.controller) {
//                invokeServiceWorkerUpdateFlow(reg);
//              } else {
//                console.log('Service Worker installed (first run)');
//              }
//            }
//          });
//        });
//
//        let refreshing = false;
//        navigator.serviceWorker.addEventListener('controllerchange', () => {
//          if (!refreshing) {
//            refreshing = true;
//            window.location.reload();
//          }
//        });
//      } catch (err) {
//        console.error('[SW] register failed:', err);
//      }
//    });
//  }
//
//  // ---- A2HS (Add to Home Screen) Handling
//  window.addEventListener('beforeinstallprompt', (e) => {
//    //e.preventDefault();
//    deferredPrompt = e;
//    maybeShowInstallBox();
//  });
//
//  window.addEventListener('appinstalled', () => {
//    // Cleanup & UI schließen, wenn installiert
//    deferredPrompt = null;
//    localStorage.removeItem(DISMISS_KEY);
//    installBox(false);
//  });
//
//  // Falls die Seite ohne beforeinstallprompt geladen wurde, UI sauber verstecken
//  document.addEventListener('DOMContentLoaded', () => {
//    if (!isStandalone()) installBox(false); // versteckt, bis Prompt möglich ist
//  });

